"import client";

import { mapIcon } from "../../assets";
import ModalContainer from "../modal/modal-container";

const StatusProgress = ({ closeModal, modalBackButton, history }) => {
  const deliveryStatusLabels = {
    PICKED_UP: { label: "Picked up" },
    READY: { label: "Ready" },
    BOOKING: { label: "Booking" },
    PROCESSING: { label: "Processing" },
    CONFIRMED: { label: "Confirmed" },
    DELIVERED: { label: "Delivered" },
    ENROUTE: { label: "En route" },
    AT_DESTINATION: { label: "At destination" },
    RETURNED: { label: "Returned" },
    MISSING: { label: "Missing" },
    DAMAGED: { label: "Damaged" },
    CANCELLED: { label: "Cancelled" },
  };

  const formatDateTime = (dateString) => {
    const date = new Date(dateString);

    const day = String(date.getDate()).padStart(2, "0");

    const month = date.toLocaleString("en-US", {
      month: "short",
    });

    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");

    const ampm = hours >= 12 ? "pm" : "am";
    hours = hours % 12 || 12; // convert 0 to 12

    return `${day} ${month} ${year}, ${hours}:${minutes}${ampm}`;
  };

  return (
    <ModalContainer closeModal={closeModal} modalBackButton={modalBackButton}>
      <div className="delivery-progress-container">
        <h2>Order Tracking Timeline </h2>
        {history && history.length > 0 ? (
          <div className="delivery-progress-list">
            <div className="delivery-progress-div">
              {[...history].reverse().map((h) => (
                <div key={h.id} className="delivery-progress-item">
                  <span className="delivery-progress-dot" />
                  <h3>{deliveryStatusLabels[h.deliveryStatus].label}</h3>
                  <p>{formatDateTime(h.deliveryStatusDate)}</p>
                  {h.deliveryComment && <p>Comment: {h.deliveryComment}</p>}
                  {h.deliveryDestination && (
                    <p className="delivery-destination">
                      {mapIcon} {h.deliveryDestination}
                    </p>
                  )}
                </div>
              ))}
            </div>
          </div>
        ) : (
          <p>No delivery history available.</p>
        )}
      </div>
    </ModalContainer>
  );
};
export default StatusProgress;
